<div class="container-fluid g-0 m-0">
  <div class="d-flex g-0 m-0">
    <div class="sidemenu-nav background-color">
      <h6 class="sidemenu-title">
        {{ "TARIFF_MENU_DEVICESETUP&MANAGEMENT" | translate }}
      </h6>
      <div
        class="sidemenu-item-font item"
        (click)="toggleModal(item.ManageTariffs)"
        [ngClass]="{ selected: selectedItem === item.ManageTariffs }"
      >
        <span>{{ "TARIFF_MENU_MANAGEDEVICES" | translate }}</span>
      </div>
      <div
        class="sidemenu-item-font item"
        (click)="toggleModal(item.TariffSetup)"
        [ngClass]="{ selected: selectedItem === item.TariffSetup }"
      >
        <span>{{ "TARIFFS_MENU_TARIFFSETUP" | translate }}</span>
      </div>
    </div>
    <div class="sidemenu-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
